import { render, staticRenderFns } from "./PeppolContactRegistrationStatus.vue?vue&type=template&id=6eae9061&scoped=true"
import script from "./PeppolContactRegistrationStatus.vue?vue&type=script&lang=ts"
export * from "./PeppolContactRegistrationStatus.vue?vue&type=script&lang=ts"
import style0 from "./PeppolContactRegistrationStatus.vue?vue&type=style&index=0&id=6eae9061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eae9061",
  null
  
)

export default component.exports